(function () {
    'use strict';

    angular.module('ecap.workflow', []);
})();